import React from 'react';

/* Microsoft logo – inline SVG keeps us dependency-free */
const MsIcon = () => (
    <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
);

const HeroSection = ({ onSignIn, onSignUp }) => {
    return (
        <section className="lp-hero">
            <div className="lp-hero-inner">
                <div className="lp-hero-grid">
                    {/* ── Left: brand logo ── */}
                    <div className="lp-hero-brand">
                        <img
                            src="/assets/branding/Finlytics_Forge_Logo.svg"
                            alt="Finlytics Forge"
                            className="lp-brand-logo"
                        />
                    </div>

                    {/* ── Right: content stack ── */}
                    <div className="lp-hero-content">
                        <div className="lp-hero-badge">
                            <span aria-hidden="true">▸</span> Source-grounded financial intelligence
                        </div>

                        <h1>
                            Decode company financials<br />
                            with <span className="highlight">AI-powered</span> precision
                        </h1>

                        <p className="lp-hero-sub">
                            Upload annual reports, ask questions in plain English, and get cited answers
                            backed by real data — not hallucinations. Built for analysts, investors, and
                            finance teams.
                        </p>

                        <div className="lp-hero-ctas">
                            <button className="lp-btn-primary" onClick={onSignIn} type="button">
                                <MsIcon /> Sign in with Microsoft
                            </button>
                            <button className="lp-btn-secondary" onClick={onSignUp} type="button">
                                Create Account
                            </button>
                        </div>

                        <p className="lp-hero-disclaimer">
                            Finlytics provides analytics only — no investment recommendations or trading signals.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
